<template>
    <div>
        <headline-container headline="Portals" :breadcrumbs="[{text: 'Portals'}]">
            <router-link v-if="hasPermission('admin')" to="/portals/create" class="btn btn-white">
                <i class="fa fa-plus"></i> Create
            </router-link>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                        <tr>
                            <th class="col-xs-1 text-center">
                                <input type="checkbox" v-model="selectAll">
                            </th>

                            <th class="col-xs-22">
                                Name
                            </th>

                            <th class="col-xs-1"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="portal in portals">
                            <td class="text-center">
                                <input type="checkbox" v-model="selected" :value="portal">
                            </td>

                            <td>
                                <router-link :to="'/portals/' + portal.id">
                                    {{ portal.attributes.name }}
                                </router-link>
                            </td>

                            <td class="text-right">
                                <div class="btn-group list-actions">
                                    <router-link :to="'/portals/' + portal.id" class="btn btn-sm">
                                        <i class="fa fa-search"></i>
                                    </router-link>

                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        @click="destroy(portal)"
                                        :disabled="!hasPermission('admin')"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr v-if="!portals.length">
                            <td colspan="3" class="text-center">
                                <i>
                                    There are no portals to display.
                                </i>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="dropdown" v-if="selected.length">
                        <button
                            class="btn btn-black btn-sm dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                        >
                            <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                        </button>

                        <ul class="dropdown-menu">
                            <li>
                                <a href="#" @click.prevent="destroySelected">
                                    <i class="fa fa-trash"></i> Delete
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import Permissions from '@/mixins/Permissions'

export default {
    components: {HeadlineContainer, LoadingContainer},

    mixins: [Permissions],

    data() {
        return {
            portals: [],
            loading: true,
            selected: [],
            selectAll: false
        }
    },

    watch: {
        selectAll(value) {
            this.selected = value ? this.portals : []
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        load() {
            this.loading = true

            http.get('/api/v2/portals', this.filters)
                .then(response => {
                    this.portals = response.data.data

                    this.loading = false
                })
        },

        destroy(portal) {
            modal.confirm('Are you sure that you want to delete the portal?', () => {
                this.getDestroyPromise(portal)
                    .then(() => {
                        notify.success('The portal was deleted')

                        this.load()
                    })
            })
        },

        destroySelected() {
            modal.confirm('Are you sure that you want to delete the portals?', () => {
                axios.all(this.selected.map(portal => this.getDestroyPromise(portal)))
                    .then(() => {
                        notify.success('The portals were deleted')

                        this.load()

                        this.resetSelections()
                    })
            })
        },

        getDestroyPromise(portal) {
            return http.delete('/api/v2/portals/' + portal.id)
        },

        resetSelections() {
            this.selected = []

            this.selectAll = false
        }
    }
}
</script>
